import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CommissionConfirmation from '../../../CommissionEditPopup/CommissionConfirmation';
import IconButton from '../../../Button/IconButton/IconButton';
import LockIcon from '../../../Icons/Lock';
import UnlockIcon from '../../../Icons/Unlock';
import { CommissionStatusCodes, CommissionStatusType, } from '../../../types/commissions';
import s from './CommissionStatusControl.scss';
export var CommissionStatusControl = function (_a) {
    var isOwner = _a.isOwner, deviation = _a.deviation, changeCommissionStatus = _a.changeCommissionStatus;
    var t = useTranslation().t;
    var _b = useState(false), showConfirmationPopup = _b[0], setShowConfirmationPopup = _b[1];
    if (!deviation.commission ||
        !isOwner ||
        deviation.commission.status === CommissionStatusCodes.STATUS_DELETED) {
        return null;
    }
    var isActive = deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE;
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { tooltipText: isActive
                ? t('actionbar.closeCommission')
                : t('actionbar.openCommission'), onClick: function () { return setShowConfirmationPopup(true); }, className: s['actionbar-button'] }, isActive ? React.createElement(UnlockIcon, null) : React.createElement(LockIcon, null)),
        showConfirmationPopup && (React.createElement(CommissionConfirmation, { isOpen: true, confirmationType: isActive ? 'disable' : 'enable', onCancel: function () { return setShowConfirmationPopup(false); }, onConfirm: function () {
                setShowConfirmationPopup(false);
                changeCommissionStatus({
                    deviation: deviation,
                    status: isActive
                        ? CommissionStatusType.DISABLED
                        : CommissionStatusType.ACTIVE,
                });
            } }))));
};
CommissionStatusControl.displayName = 'CommissionStatusControl';
export default CommissionStatusControl;
//# sourceMappingURL=CommissionStatusControl.js.map